export class MiniQuestionGlobalQuestion {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get miniQuestion() {
        return this.parent;
    }
    get app() {
        return this.miniQuestion.app;
    }
    get availableQuestion() {
        return this.app.model.available.question[this.miniQuestion.id];
    }
    // @computed
    get preloadQuestion() {
        return this.app.model.stream.question[this.miniQuestion.id];
    }
}
